import { reduce } from "et3-type-guards";
import React from "react";

import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import { TMenuDropDownItemProps } from "../../../Types";
import AnimatedDropdown from "./AnimatedDropdown";
import SideBarRow from "./SideBarRow";

const MenuDropdownItem = withLiteObserverAndTheme<TMenuDropDownItemProps>(
  (props) => {
    const { icon, title, options, isMenuOpenObservable, onPress, visible } =
      props;
    const isMenuOpen = isMenuOpenObservable.get();
    const currentPageName = getCoreHistoryStore().getPageName();
    const isGroupActive = options.some(
      (option) => reduce(() => option.pageName, "") === currentPageName
    );

    return visible ? (
      <React.Fragment>
        <SideBarRow
          icon={icon}
          title={title}
          isActive={isGroupActive}
          isOpen={isMenuOpen}
          hasChevron={true}
          onPress={() => {
            onPress();
            isMenuOpenObservable.set(!isMenuOpen);
          }}
        />
        <AnimatedDropdown options={options} isMenuOpen={isMenuOpen} />
      </React.Fragment>
    ) : null;
  }
);
export default MenuDropdownItem;
